require.context("images", true)

require.context("stylesheets", false, /^stylesheets\/[^_]/)
require.context("stylesheets/monkey_patches/", true)
